var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ApiCallService } from './api-call.service';
import { BaseApiService } from './base-api.service';
var AdvancedLimitsService = /** @class */ (function (_super) {
    __extends(AdvancedLimitsService, _super);
    function AdvancedLimitsService(apiCallService) {
        var _this = _super.call(this) || this;
        _this.apiCallService = apiCallService;
        return _this;
    }
    AdvancedLimitsService.prototype.getAdvancedLimits = function (propertyType) {
        this.validateString(propertyType, 'property_type');
        return this.apiCallService.get('/new_properties/advanced_limits/' + propertyType);
    };
    AdvancedLimitsService.prototype.resolve = function (route) {
        var promise = this.getAdvancedLimits(route.data['property_type']);
        return promise;
    };
    return AdvancedLimitsService;
}(BaseApiService));
export { AdvancedLimitsService };



// WEBPACK FOOTER //
// ./src/app/common-theme/api/advanced-limits.service.ts.pre-build-optimizer.js